import { useGet } from '../../../sharedModules/hooks/useQuery';
import { DepartmentAssignment } from '../model';

const URL = '/collections/department_assignments';

export function departmentAssignmentsUrl() {
  return URL;
}

export function useDepartmentAssignments(location: string) {
  return useGet<DepartmentAssignment[]>({ url: URL, params: { location } });
}
